/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age Calculator — Your Exact Age in Years, Months, Days | Toolverse`)
};

const es_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Edad — Tu Edad Exacta en Años, Meses, Días | Toolverse`)
};

const de_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altersrechner — Ihr genaues Alter in Jahren, Monaten, Tagen | Toolverse`)
};

const nl_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeftijdscalculator — Uw Exacte Leeftijd in Jaren, Maanden, Dagen | Toolverse`)
};

const fr_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice d'âge — Votre âge exact en années, mois, jours | Toolverse`)
};

const it_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore dell'età — La tua età esatta in anni, mesi, giorni | Toolverse`)
};

const pt_br2_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Idade — Sua Idade Exata em Anos, Meses, Dias | Toolverse`)
};

const pt_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Idade — A Sua Idade Exata em Anos, Meses e Dias | Toolverse`)
};

const ja_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢計算機 — 年、月、日単位での正確な年齢 | Toolverse`)
};

const zh_age_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年龄计算器——精确计算年、月、日 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_meta_title", locale)
	if (locale === "en") return en_age_meta_title(inputs)
	if (locale === "es") return es_age_meta_title(inputs)
	if (locale === "de") return de_age_meta_title(inputs)
	if (locale === "nl") return nl_age_meta_title(inputs)
	if (locale === "fr") return fr_age_meta_title(inputs)
	if (locale === "it") return it_age_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_age_meta_title(inputs)
	if (locale === "pt") return pt_age_meta_title(inputs)
	if (locale === "ja") return ja_age_meta_title(inputs)
	return zh_age_meta_title(inputs)
};